import * as React from 'react';
import { observer } from 'mobx-react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';
import { ReviewCard } from '../ReviewCard';
import { Message } from '../Messages';
import { MessageType } from '../Messages/Message';
import { IconArrowBottom } from '../../../../../components/icons/IconArrowBottom';
import { HotelReview } from '../../../../models/hotel-reviews';
import S from '../../../../stores';

export interface ReviewsListProps {
    reviewList?: HotelReview[];
}

interface StyledReviewListProps extends JSSClassesProps<ComponentJSSClasses>, ReviewsListProps {}

export const ReviewsList = observer((props: StyledReviewListProps) => {
    const { classes, reviewList } = props;

    const handleLoadMoreReviews = () => {
        S.hotelReviews.getMoreReviews();
    };

    const isAllReviewsLoaded = (): boolean =>
        S.hotelReviews.filteredReviewAmount ===
        S.hotelReviews.hotelReviews.length;

    const reviewNotFound = (): boolean =>
        Boolean(!reviewList?.length &&
            S.hotelReviews.totalReviewAmount &&
            !S.hotelReviews.errorReviewsLoading);

    return (
        <main className={classes.container}>
            {reviewList?.length
                ? reviewList?.map((review, idx) => (
                      <ReviewCard
                          review={review}
                          key={`${review.hotelId}-${review.creationDate}-${idx}`}
                      />
                  ))
                : null}
            {reviewList?.length && !isAllReviewsLoaded() ? (
                <button
                    className={classes.showMoreButton}
                    onClick={handleLoadMoreReviews}
                    type="button"
                >
                    Показать ещё <IconArrowBottom />
                </button>
            ) : null}

           {S.hotelReviews.errorReviewsLoading && <Message type={MessageType.Error} />}
           {reviewNotFound() && <Message type={MessageType.NotFound} />}
        </main>
    );
});
